(function () {
  'use strict';

  var MONTH_NAMES = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var DAY_LABELS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

  function hexToRgb(hex) {
    hex = hex.replace('#', '');
    return {
      r: parseInt(hex.substring(0, 2), 16),
      g: parseInt(hex.substring(2, 4), 16),
      b: parseInt(hex.substring(4, 6), 16)
    };
  }

  function blendWithWhite(rgb, opacity) {
    return 'rgb(' +
      Math.round(255 + (rgb.r - 255) * opacity) + ',' +
      Math.round(255 + (rgb.g - 255) * opacity) + ',' +
      Math.round(255 + (rgb.b - 255) * opacity) + ')';
  }

  function formatDate(d) {
    return MONTH_NAMES[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear();
  }

  function buildHeatmap(container) {
    var monthsToShow = parseInt(container.getAttribute('data-months'), 10) || 12;
    var accentColor = container.getAttribute('data-accent-color') || '#e20c90';
    var showLegend = container.getAttribute('data-show-legend') !== 'false';

    // Preferred source: blog-wide history precomputed by
    // scripts/build-post-history.rb, inlined as a { "YYYY-MM-DD": count }
    // map. Falls back to the data-post-dates array (one Liquid page)
    // when the precompute hasn't run yet or yielded nothing.
    var dateCounts = {};
    var maxCount = 0;

    var precomputed = null;
    var dataEl = document.getElementById('cps-post-history');
    if (dataEl) {
      try {
        precomputed = JSON.parse(dataEl.textContent);
      } catch (e) {
        precomputed = null;
      }
    }

    if (precomputed && Object.keys(precomputed).length > 0) {
      dateCounts = precomputed;
      for (var key in dateCounts) {
        if (dateCounts[key] > maxCount) maxCount = dateCounts[key];
      }
    } else {
      var dates;
      try {
        dates = JSON.parse(container.getAttribute('data-post-dates'));
      } catch (e2) {
        dates = [];
      }
      for (var i = 0; i < dates.length; i++) {
        var d = dates[i];
        dateCounts[d] = (dateCounts[d] || 0) + 1;
        if (dateCounts[d] > maxCount) maxCount = dateCounts[d];
      }
    }

    // Calculate date range: today back to monthsToShow months ago
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    var endDate = new Date(today);

    var startDate = new Date(today);
    startDate.setMonth(startDate.getMonth() - monthsToShow);
    // Align to Sunday
    startDate.setDate(startDate.getDate() - startDate.getDay());

    // Generate color levels
    var rgb = hexToRgb(accentColor);
    var colors = [
      '#ebedf0',
      blendWithWhite(rgb, 0.2),
      blendWithWhite(rgb, 0.45),
      blendWithWhite(rgb, 0.7),
      accentColor
    ];

    // Set CSS custom properties
    container.style.setProperty('--heatmap-l1', colors[1]);
    container.style.setProperty('--heatmap-l2', colors[2]);
    container.style.setProperty('--heatmap-l3', colors[3]);
    container.style.setProperty('--heatmap-l4', colors[4]);

    // Build grid data
    var weeks = [];
    var currentWeek = [];
    var cursor = new Date(startDate);

    while (cursor <= endDate) {
      var dayOfWeek = cursor.getDay();
      var dateStr = cursor.getFullYear() + '-' +
        String(cursor.getMonth() + 1).padStart(2, '0') + '-' +
        String(cursor.getDate()).padStart(2, '0');
      var count = dateCounts[dateStr] || 0;

      // Fixed count buckets rather than ratio-to-max. This blog's active
      // days cluster around a median of ~12 posts with a tail up to 40+,
      // so scaling off the single busiest day (or a low ≥5 cutoff) would
      // collapse almost every active day into one shade. These cutoffs
      // are roughly quartile-aligned so all four greens get used.
      var level = 0;
      if (count >= 20) level = 4;
      else if (count >= 12) level = 3;
      else if (count >= 5) level = 2;
      else if (count >= 1) level = 1;

      currentWeek.push({
        date: new Date(cursor),
        dateStr: dateStr,
        count: count,
        level: level,
        dayOfWeek: dayOfWeek
      });

      if (dayOfWeek === 6 || cursor.getTime() === endDate.getTime()) {
        weeks.push(currentWeek);
        currentWeek = [];
      }

      cursor.setDate(cursor.getDate() + 1);
    }

    // Build DOM
    var scrollContainer = document.createElement('div');
    scrollContainer.className = 'heatmap__scroll-container';

    var wrapper = document.createElement('div');
    wrapper.className = 'heatmap__wrapper';

    // Day labels
    var dayLabelsEl = document.createElement('div');
    dayLabelsEl.className = 'heatmap__day-labels';
    for (var d = 0; d < 7; d++) {
      var label = document.createElement('span');
      label.textContent = (d % 2 === 1) ? DAY_LABELS[d] : '';
      label.style.height = '11px';
      label.style.lineHeight = '11px';
      dayLabelsEl.appendChild(label);
    }
    wrapper.appendChild(dayLabelsEl);

    // Month labels
    var monthLabelsEl = document.createElement('div');
    monthLabelsEl.className = 'heatmap__month-labels';
    var lastMonth = -1;
    var colWidth = 13; // 11px cell + 2px gap
    for (var w = 0; w < weeks.length; w++) {
      var firstDayOfWeek = weeks[w][0];
      var month = firstDayOfWeek.date.getMonth();
      if (month !== lastMonth) {
        var monthLabel = document.createElement('span');
        monthLabel.className = 'heatmap__month-label';
        monthLabel.textContent = MONTH_NAMES[month];
        monthLabel.style.position = 'absolute';
        monthLabel.style.left = (w * colWidth) + 'px';
        monthLabelsEl.appendChild(monthLabel);
        lastMonth = month;
      }
    }
    wrapper.appendChild(monthLabelsEl);

    // Grid
    var grid = document.createElement('div');
    grid.className = 'heatmap__grid';
    grid.style.gridTemplateColumns = 'repeat(' + weeks.length + ', 11px)';

    // Fill grid column by column (each column = one week, top to bottom = Sun to Sat)
    for (var w = 0; w < weeks.length; w++) {
      var week = weeks[w];
      // For incomplete first/last weeks, pad with empty cells
      var weekMap = {};
      for (var j = 0; j < week.length; j++) {
        weekMap[week[j].dayOfWeek] = week[j];
      }
      for (var day = 0; day < 7; day++) {
        var cell = document.createElement('div');
        cell.className = 'heatmap__cell';
        if (weekMap[day]) {
          var entry = weekMap[day];
          if (entry.level > 0) {
            cell.classList.add('heatmap__cell--level-' + entry.level);
          }
          cell.setAttribute('data-date', entry.dateStr);
          cell.setAttribute('data-count', entry.count);
        } else {
          cell.style.visibility = 'hidden';
        }
        grid.appendChild(cell);
      }
    }
    wrapper.appendChild(grid);
    scrollContainer.appendChild(wrapper);
    container.appendChild(scrollContainer);

    // Scroll to the right (most recent) on mobile
    scrollContainer.scrollLeft = scrollContainer.scrollWidth;

    // Legend
    if (showLegend) {
      var legend = document.createElement('div');
      legend.className = 'heatmap__legend';
      var lessSpan = document.createElement('span');
      lessSpan.textContent = 'Less';
      legend.appendChild(lessSpan);
      for (var l = 0; l < colors.length; l++) {
        var legendCell = document.createElement('span');
        legendCell.className = 'heatmap__legend-cell';
        legendCell.style.backgroundColor = colors[l];
        legend.appendChild(legendCell);
      }
      var moreSpan = document.createElement('span');
      moreSpan.textContent = 'More';
      legend.appendChild(moreSpan);
      container.appendChild(legend);
    }

    // Tooltip
    var tooltip = document.createElement('div');
    tooltip.className = 'heatmap__tooltip';
    document.body.appendChild(tooltip);

    grid.addEventListener('mouseover', function (e) {
      var target = e.target;
      if (!target.classList.contains('heatmap__cell') || !target.hasAttribute('data-date')) return;

      var count = parseInt(target.getAttribute('data-count'), 10);
      var dateStr = target.getAttribute('data-date');
      var parts = dateStr.split('-');
      var dateObj = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));
      var formatted = formatDate(dateObj);

      if (count === 0) {
        tooltip.textContent = 'No posts on ' + formatted;
      } else if (count === 1) {
        tooltip.textContent = '1 post on ' + formatted;
      } else {
        tooltip.textContent = count + ' posts on ' + formatted;
      }

      var rect = target.getBoundingClientRect();
      tooltip.style.left = (rect.left + rect.width / 2) + 'px';
      tooltip.style.top = (rect.top - 36) + 'px';
      tooltip.classList.add('heatmap__tooltip--visible');
    });

    grid.addEventListener('mouseout', function (e) {
      if (e.target.classList.contains('heatmap__cell')) {
        tooltip.classList.remove('heatmap__tooltip--visible');
      }
    });
  }

  function init() {
    var containers = document.querySelectorAll('.heatmap__container');
    for (var i = 0; i < containers.length; i++) {
      buildHeatmap(containers[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
